import qs from 'qs'

define([
  'app',
  '../helpers/dropdown',
  'axios',
  'jquery'
], function (app, Dropdown, axios, $) {
  return app.Marionette.ItemView.extend({
    template: false,

    ui: {
      topicTypeButton: '.radio-box-button',
      ideaButton: '#topic_content_type_idea',
      subForumDropdown: '.editor__subject select',
      forumSelector: '.editor__subject',
      productAreaSelector: '.topic-create_product-areas',
      tagSelector: '[data-helper=input-tags]',
      notification: '.js-notification',
      submit: '.topic-create_submit button'
    },

    events: {
      'change @ui.topicTypeButton': 'onChangeTopicType',
      'submit @ui.submit': 'onSubmit',
      'click @ui.submit': 'onSubmit'
    },

    options: {
      type: 0,
      forumTree: []
    },

    /**
     *
     * @param options
     * @returns {exports}
     */
    initialize: function () {
      const dropdown = new Dropdown({ el: this.ui.subForumDropdown, create: false })

      this.subForumDropdown = dropdown.el.selectize
      this.currentType = this.getOption('type') || 0
      this.newsType = 3
      this.ideationType = 2
      this.previousType = null
      this.updateSubForumDropdown()

      return this
    },

    onRender: function () {
      this.setIdeationSpecifications()
      const queryParameters = qs.parse(window.location.search, { ignoreQueryPrefix: true })

      if (queryParameters && queryParameters.type === 'idea') {
        this.ui.ideaButton.trigger('click')
      }
    },

    onSubmit: function (e) {
      if (!this.options.ideationV2 || this.currentType !== this.ideationType.toString()) {
        return
      }
      e.stopPropagation()
      e.preventDefault()
      const requestData = {
        csrfToken: this.options.csrfToken,
        sticky: false,
        closed: false
      }
      const formData = $('form.js-wysiwyg-form').serializeArray()
      formData.forEach(({ name, value }) => {
        if (name === 'topic[title]') {
          requestData.title = value
        } else if (name === 'topic[firstPost][content]') {
          requestData.content = value
        } else if (name === 'topic[tags]') {
          requestData.tags = value.split(',').filter(val => val !== '')
        } else if (name === 'topic[productAreas]') {
          requestData.productAreaIds = value
        }
      })
      axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': this.options.csrfToken
      }
      this.ui.submit[0].classList.add('is-loading')

      axios.post('/community/api/ideas/submit', requestData)
        .then(async function (data) {
          this.ui.submit[0].classList.remove('is-loading')
          const location = data.headers.location
          const id = location.split('/').pop()

          const isSpamResponse = await app.libs.isSpam(id, 'idea', false)
          const { isSpam } = isSpamResponse.data.result

          if (isSpam) {
            const errorMessage = this.options.spamPhrase
            this.ui.submit[0].classList.remove('is-loading')
            this.ui.notification[0].innerHTML = `<div class="box box__pad box--alert"><ul><li>${errorMessage}</li></ul></div>`
            this.ui.notification[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
            return
          }

          window.location.assign(`/ideas/${id}`)
        }.bind(this))
        .catch(function () {
          const errorMessage = this.options.phrase
          this.ui.submit[0].classList.remove('is-loading')
          this.ui.notification[0].innerHTML = `<div class="box box__pad box--alert"><ul><li>${errorMessage}</li></ul></div>`
          this.ui.notification[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
        }.bind(this))
    },

    /**
     * @param newType
     * @returns {exports}
     */
    switchTopicType: function (newType) {
      this.previousType = this.currentType
      this.currentType = newType
      this.setIdeationSpecifications()

      this.updateSubForumDropdown()

      return this
    },

    /**
     *
     * @param e
     * @returns {exports}
     */
    onChangeTopicType: function (e) {
      this.ui.topicTypeButton.removeClass('is-active').filter(e.currentTarget).addClass('is-active')
      this.switchTopicType(e.target.value)

      return this
    },

    shouldIncludeCategory: function (forum) {
      if (parseInt(this.currentType, 10) === this.ideationType) {
        return app._.contains(forum.types, parseInt(this.currentType, 10))
      }

      return app._.intersection(forum.types, [parseInt(this.currentType, 10), this.newsType, 4, 5]).length > 0
    },

    setIdeationSpecifications: function () {
      if (this.options.ideationV2 && this.currentType === this.ideationType.toString()) {
        this.ui.forumSelector.hide()
        this.ui.productAreaSelector.show()
        if (!this.options.productAreas) {
          this.ui.tagSelector.hide()
        }
      } else {
        this.ui.forumSelector.show()
        this.ui.tagSelector.show()
        this.ui.productAreaSelector.hide()
      }
    },

    /**
     *
     * @returns {exports}
     */
    updateSubForumDropdown: function () {
      const self = this
      const optionsList = this.options.forumTree
      const currentSelected = this.subForumDropdown.getValue()
      // Remove the current options
      this.subForumDropdown.options = {}
      this.subForumDropdown.clearOptionGroups()
      this.subForumDropdown.clearOptions()

      // Loop over all forums, find the
      app._.forEach(optionsList, function (category, categoryID) {
        categoryID = categoryID.toString()

        self.subForumDropdown.addOptionGroup(categoryID, { label: category.label })

        app._.forEach(category.subForums, function (forum, forumID) {
          if (self.shouldIncludeCategory(forum)) {
            self.subForumDropdown.addOption({ text: forum.label, value: forumID, optgroup: categoryID })
          }
        })
      })
      // Do not re-select the 'old' value when selecting ideation manually
      // If previousType is null, create topic in category view clicked, retain category selection for ideation
      if ((this.currentType === this.ideationType && this.previousType != null) || this.previousType === this.ideationType) {
        this.subForumDropdown.clear()
      } else {
      // Re-select the 'old' value when question or conversation
        this.subForumDropdown.setValue(currentSelected)
      }

      return this
    }
  })
})
